export const handleSearch = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  Employeedata: any[],
  setFilteredData: (data: any[]) => void,
  setSearchTerm: (val: string) => void,
  setPage: (val: number) => void
) => {
  let value = event.target.value;
  value = value.replace(/[!@#$%^&?*<>|/{}():_+=";'.,[\]`-]/g, "");
  setSearchTerm(value);
  if (value.trim() === "") {
    setFilteredData(Employeedata);
  } else {
    const formattedValue = value.trim().toLowerCase();
    const filtered = Employeedata.filter((item) =>
      (item.phone_number && item.phone_number.toLowerCase().includes(formattedValue)) ||
      (item.employee_name && item.employee_name.toLowerCase().includes(formattedValue)) ||
      (item.name && item.name.toLowerCase().includes(formattedValue)) ||
      (item.user_name && item.user_name.toLowerCase().includes(formattedValue))
    );
    setFilteredData(filtered);
    setPage(0);
  }
};
